import apiFetch from '../apiFetch'

export default function (idAnalisisExtraccion) {
  return apiFetch({endPoint: `Analisis/getAnalisis?idAnalisis=${idAnalisisExtraccion}`, method: 'GET', body: null})
}
